import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navigation.css'
import ghLogo from './gh.png'
import linkedInLogo from './linkedin.png'

const Navigation = () => {
  const [navBurger, setNavBurger] = useState({isActive: false});

  const toggleNavBurger = (e) => {
    if (e.target.classList.contains('navbar-burger')) {
      setNavBurger(prev => ({isActive: !prev.isActive }))
    }
  }
  const closeNavBurger = () => {
    setNavBurger(() => ({ isActive: false }))
  }

  return (
    <nav className="navbar" role="navigation" aria-label="main navigation">
      <div className="navbar-brand">
        <a className="navbar-item">
          <Link className="logo"to="/">SAKI C</Link>
        </a>
      <div onClick={(e) => {toggleNavBurger(e)}} className="has-dropdown is-hoverable">
        <a role="button" className="navbar-burger" aria-label="menu" data-target="navbarBasicExample">
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
            <div className={`navbar-dropdown ${navBurger.isActive ? "" : "hidden"}`}>
              <a onClick={closeNavBurger} className="navbar-item drop-item">
                <Link to="/">Home</Link>
              </a>
              <a onClick={closeNavBurger} className="navbar-item drop-item">
                <Link to="/about">About</Link>
              </a>
              <a onClick={closeNavBurger} className="navbar-item drop-item">
                <Link to="/projects">Projects</Link>
              </a>
              <a onClick={closeNavBurger} className="navbar-item drop-item">
                <Link to="/contact">Contact</Link>
              </a>
            </div>
        </a>
      </div>   
      </div>
      <div id="navbarBasicExample" className="navbar-menu">
        <div className="navbar-start">
          <a className="navbar-item">
            <Link to="/">Home</Link>
          </a>
          <a className="navbar-item">
          <Link to="/about">About</Link>
          </a>
          <a className="navbar-item">
            <Link to="/projects">Projects</Link>
          </a>
          <a className="navbar-item">
            <Link to="/contact">Contact</Link>
          </a>
        </div>
      </div>
      <div className='social-media-container'>
          <a href="https://github.com/sakisandrac"><img alt="github icon"tabIndex={0} className='icon' src={ghLogo} /></a>
          <a href="https://www.linkedin.com/in/saki-c-a7306b259/"><img alt="linked in icon" tabIndex={0} className='icon' src={linkedInLogo} /></a>
        </div>
    </nav>
  )
}

export default Navigation